import React from "react";
import {resetRoadmap, resetDisplayPointer, addDisplayTile} from "@/modules/commonRoadmapLarge";
import { IRoadmapLargeClass } from "@/types/RoadmapLargeTypes";
import nary from "@/modules/nary";

export default class M13 extends IRoadmapLargeClass {
	render() {
		const roadmapArray = [];
		for (let a = 0; a < 9; a++)
			roadmapArray[a] = [];
		
		const history = this.props.history;

		//Obligatory counters
		let currentType = "";
		
		resetRoadmap(this, 12);
		resetDisplayPointer(this);
		
		// Formats history to desired roadmap
		switch (this.props.filter) {
			case "small-big":
				history.forEach(item => {
					let ele = null;
					const angka = Number(item.angka);
					
					if (angka <= 7 && angka > 0) {
						currentType = "small";
						ele = <div className="sl-roadmap-circle sl-roadmap-red" />;
					} else if (angka === 8) {
						currentType = "black";
						ele = <div className="sl-roadmap-circle sl-roadmap-green">-</div>;
					} else {
						currentType = "big";
						ele = <div className="sl-roadmap-circle sl-roadmap-black" />;
					}
					
					addDisplayTile(roadmapArray, ele, currentType, this);
				});
			break;
			default: return null;
		}
				
		// Fills the roadmap with active data
		const roadmapTable = 
				(<table className="roadmap-table">
					<tbody>
					{
						nary(8).map(row => 
							<tr key={row}>
							{
								nary(12).map(col =>
									(
										<td key={col}>
										{
											roadmapArray[row - 1][col + this.firstDisplayedCol] !== undefined ?
											roadmapArray[row - 1][col + this.firstDisplayedCol] : null
										}
										</td>
									)
								)
							}
							</tr>
						)
					}
					</tbody>
				</table>);
				
		return roadmapTable;
	}
}
